import { Box, Typography, Button, Container } from '@mui/material';
import { m } from 'framer-motion';
import { varBounce, MotionContainer } from 'src/components/animate';
import { SeverErrorIllustration } from 'src/assets/illustrations';
import { getMainDomainUrl } from 'src/utils/domainContext';

// ------------------------------------------------
// TENANT NOT FOUND PAGE
// Shown when a subdomain does not map to any registered tenant.
// ------------------------------------------------
export default function TenantNotFoundPage() {
  return (
    <Container component={MotionContainer} sx={{ textAlign: 'center', py: 10 }}>
      <m.div variants={varBounce().in}>
        <Typography variant="h3" gutterBottom>
          Tenant Not Found
        </Typography>
      </m.div>

      <m.div variants={varBounce().in}>
        <Typography sx={{ color: 'text.secondary', mb: 5 }}>
          The organization you are looking for does not exist or has not been registered on
          MeruDesk.
        </Typography>
      </m.div>

      <m.div variants={varBounce().in}>
        <SeverErrorIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
      </m.div>

      <Button
        size="large"
        variant="contained"
        onClick={() => {
          window.location.href = getMainDomainUrl('/');
        }}
      >
        Go to MeruDesk
      </Button>
    </Container>
  );
}
